export default __webpack_public_path__ + "static/media/dot-pricing.6d64ecbb.png";